import * as api from "../api/index";

import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  FETCH_INVOICE_BY_USER,
  FETCH_ALL,
  START_LOADING,
  END_LOADING,
  FETCH_PAGE,
  GROUP_DOWNLOAD_JOB_START,
  GROUP_DOWNLOAD_JOB_UPDATE,
} from "./constants";

export const getInvoices = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoices();
    console.log(data);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getInvoicesByPage = (page, limit, startDate, endDate, salesperson, party, searchQuery, selectedFilter) => async (dispatch) => {
  try {
    // debugger
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByPage(page, limit, startDate, endDate, salesperson, party, searchQuery, selectedFilter);
    console.log(data);
    dispatch({ type: FETCH_PAGE, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getAllInvoicesWithFilters = (startDate, endDate, salesperson, party, searchQuery, selectedFilter) => async () => {
  try {
    const { data } = await api.fetchAllInvoicesWithFilters(startDate, endDate, salesperson, party, searchQuery, selectedFilter);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getInvoicesByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchInvoicesByUser(searchQuery);
    dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoicesByClient = (clientId) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByClient(clientId);
    console.log("Invoices by client:", data);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getInvoice = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);
    // console.log("getInvoicedata",data)

    // Business details are a nice-to-have on the preview (used for the
    // company header/logo) — a failure here must not block GET_INVOICE,
    // since the invoice itself already loaded successfully above.
    let businessDetails;
    try {
      businessDetails = await api.fetchProfilesByUser({ search: user?.result?.id });
    } catch (profileError) {
      console.log("Failed to load business details:", profileError?.response || profileError);
    }
    // console.log("Business Details: " ,businessDetails)
    const invoiceData = { ...data, businessDetails };

    // console.log("invoice Data",invoiceData)
    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};

export const createInvoice = (invoice, history) => async (dispatch) => {
  try {
    console.log("Create Invoice Called");
    dispatch({ type: START_LOADING });
    const { data } = await api.addInvoice(invoice);
    console.log("Created Invoice Data", data);
    dispatch({ type: ADD_NEW, payload: data });
    history.push(`/invoice/${data.id}`);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const startGroupDownload = (payload, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.groupInvoiceDownload(payload);
    dispatch({
      type: GROUP_DOWNLOAD_JOB_START,
      payload: {
        jobId: data.jobId,
        totalInvoices: data.totalInvoices,
        bundleSize: data.bundleSize,
        totalBundles: data.totalBundles,
      },
    });
    return data;
  } catch (error) {
    const message = error.response?.data?.message || "Group Download failed to start.";
    openSnackbar(message);
    throw error;
  }
};

export const pollGroupDownloadStatus = (jobId) => async (dispatch) => {
  try {
    const { data } = await api.fetchGroupDownloadStatus(jobId);
    dispatch({ type: GROUP_DOWNLOAD_JOB_UPDATE, payload: data });
    return data;
  } catch (error) {
    if (error.response?.status === 404) {
      dispatch({
        type: GROUP_DOWNLOAD_JOB_UPDATE,
        payload: { status: "failed", message: "Job no longer available. Please retry." },
      });
    } else {
      console.error("Group download status poll failed", error);
    }
  }
};


export const updateInvoice = (id, invoice) => async (dispatch) => {
  try {
    const { data } = await api.updateInvoice(id, invoice);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);

    dispatch({ type: DELETE, payload: id });
    openSnackbar("Order deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};
